import React from 'react'
import './LeadsThankYouPage.scss';

const ThankYouPageLeads = () => {
  return (
    <section className='TpLeads'>
      <div className='TpLeads_container'>
        <img className="TpLeads_img" src="/img/Leads/ThankYouPage/earphone.svg" alt="earphone" />
        <p className="TpLeads_title">GRACIAS</p>
        <p className="TpLeads_subtitle">
          Espere en breve el contacto con
          nuestro especialista
        </p>
        <p className="TpLeads_text">
          Si tiene <span className="TpLeads_bold">alguna duda</span> o necesita
          más información, por favor comuníquese con nosotros al teléfono o
          Whatsapp: <a
            href='https://api.whatsapp.com/send?phone=+525541606061'
            data-action="share/whatsapp/share"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className='TpLeads_bold'
          >55 4160 6061</a>
        </p>
        <hr className="TpLeads_line"/>
        <p className="TpLeads_text-mid">
          Bienvenidos a la nueva era del <b>abogado digital.</b>
        </p>
      </div>
    </section>
  );
};

export default ThankYouPageLeads;
